import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Route, Routes } from 'react-router-dom';
import { Navbar } from './app/navbar';
import { PageLoader } from './app/page-loader';
import AuthenticationGuard from './features/authentication/authentication-guard';
import CallbackPage from './pages/callback-page';
import NotFoundPage from './pages/not-found-page';
import HomePage from './pages/home-page';
import PortfoliosEditPage from './pages/portfolios-edit-page';
import PortfoliosDetailPage from './pages/portfolios-detail-page';
import PortfoliosRebalancePage from './pages/portfolios-rebalance-page';
import RebalanceImportance from './pages/rebalance-importance';
import TermsOfUse from './pages/terms-of-use';
import TestChartD3 from './pages/test-chart-d3';
import StockPage from './pages/stock-page';

export const App: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth0();

  if (isLoading) {
    return (
      <PageLoader />
    );
  } else {
    return (
      <div className='flex flex-col h-dvh w-full text-sm lg:text-base'>
        <Navbar />
        <div className='grow relative flex overflow-y-auto'>
          <Routes>
            <Route path='/' element={
              isAuthenticated ?
                <AuthenticationGuard component={PortfoliosDetailPage} /> :
                <HomePage />}
            />
            <Route path='/importancia-de-rebalancear-portfolio' element={<RebalanceImportance />} />
            <Route path='/termos-de-uso' element={<TermsOfUse />} />
            <Route path='/teste-d3-js' element={<TestChartD3 />} />
            <Route
              path='/portfolios/detail'
              element={<AuthenticationGuard component={PortfoliosDetailPage} />}
            />
            <Route
              path='/portfolios/edit'
              element={<AuthenticationGuard component={PortfoliosEditPage} />}
            />
            <Route
              path='/portfolios/rebalance'
              element={<AuthenticationGuard component={PortfoliosRebalancePage} />}
            />
            <Route
              path='/acoes'
              element={<AuthenticationGuard component={StockPage} />}
            />
            <Route path='/callback' element={<CallbackPage />} />
            <Route path='*' element={<NotFoundPage />} />
          </Routes>
        </div>
      </div>
    );
  }
};